import React from 'react'
import { Button, Group, LoadingOverlay, Modal, Stack, Text, Title } from '@mantine/core'
import { useDeleteReport } from '../../../hooks/reports/use-delete-report'
import { useHistory } from 'react-router'

type DeleteReportConfirmationModalProps = {
    opened: boolean
    onClose: () => void
    reportPk: number
}

export const DeleteReportConfirmationModal = ({ opened, onClose, reportPk }: DeleteReportConfirmationModalProps) => {
    const { mutate: deleteReport, isLoading, isSuccess, reset } = useDeleteReport()
    const history = useHistory()

    if (isSuccess) {
        onClose()
        reset()
        history.replace('/reports/library-new')
    }

    return (
        <Modal size='auto' opened={opened} onClose={onClose}>
            <LoadingOverlay visible={isLoading} />
            <Stack h={300} w={850} justify='space-between'>
                <Stack>
                    <Title order={5} fw='normal'>Delete Report</Title>
                    <Text size='xl' mt={50} ta='center'>Are you sure you want to delete this report?</Text>
                </Stack>
                <Group justify='flex-end'>
                    <Button variant='outline' onClick={onClose}>Cancel</Button>
                    <Button color='red' onClick={() => deleteReport(reportPk)}>Delete</Button>
                </Group>
            </Stack>
        </Modal>
    )
}